"use client";

import { useTranslations } from "i18n";
import { useCountryStateCookies } from "hooks/cookies/useCountryStateCookies";

export function MarsLPTakeoverSubtitleText() {
  const { isUS } = useCountryStateCookies();
  const t = useTranslations("homepage");

  return (
    <p className="mt-5! w-full! max-w-[350px]! text-[20px]! leading-[28px]! font-medium! text-[#edddca]! max-[850px]:max-w-[310px]! max-[850px]:text-center! max-[850px]:text-[18px]! max-[850px]:leading-[25px]!">
      {isUS ? t("heroSubtitleTextUS") : t("heroSubtitleText")}
    </p>
  );
}
